import moment from 'moment';

const getReportHostTasksResponse = (response) => {
  return {
    ...response,
    reports:
      response?.data?.map((report) => {
        return {
          hostName: report?.hostName || '-',
          brand: report?.brand || '-',
          date: report?.createdAt ? moment(report?.createdAt).format('DD MMM YYYY HH:mm:ss') : '-',
          videoUrls: report?.videoUrls || [],
          note: report?.note || '-',
        };
      }) || [],
  };
};

export default getReportHostTasksResponse;
